export default __webpack_public_path__ + "static/media/Hero_Image.8e720f8f.png";